<template>
	<div class="os-container">
		<!-- <base-dialog v-model="dialogVisible" :okFn="dialogOkClicked" :cancelFn="cancelClicked" :content="$t('openlegal.dialog-sign-in')"></base-dialog> -->
		<div class="nav">
			<base-button class="access-btn" negative @click="$router.push('/inicio-sesion')">{{ $t('login-wrd') }}
				<base-icon v-if="!$uiHelpers.isMobile && !$uiHelpers.isTablet" @mouseover.native="hover = true" @mouseleave.native="hover = false" src="/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg" color="white" />
			</base-button>
		</div>
		<div class="overlay"></div>
		<div class="content">
			<div class="text-center">
				<img src="/static-appopensalud/img/logos/openlegal_white.svg" class="mb-5"/>
			</div>
			<h3 class="mb-4">Revolutionizing Access to Legal Services</h3>
			<p class="mb-4">{{ $t('openlegal.promotion-question') }}</p>
			<div v-if="subscriptionDone" class="ctn-shadow">
				<p>{{ $t('openlegal.thanks-subscription')}}</p>
			</div>
			<div v-else>
				<base-input v-model="$v.form.email.$model" :placeholder="$t('openlegal.enter-your-email')" class="d-block d-md-inline-block mr-0 mr-xl-2" :state="validateState('email')" :validator="$v.form.email" ></base-input> 
				<base-button borderColor="white" backgroundColor="transparent" textColor="white" @click="signUpButtonClicked" class="d-block d-md-inline-block btn-sign-up" :loading="$store.state.loading"><base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg" white></base-icon></base-button>
			</div>
			
		</div>
	</div>
</template>

<script>
import { validationsMixin } from '@/mixins/validations.mixin'
import { email } from 'vuelidate/lib/validators'
import MarketingRepository from '@/repositories/MarketingRepository'

const i18n = {
	messages: {
		es: {
			'openlegal.promotion-question': '¿Quieres que te informemos del lanzamiento y acceder a una promoción exclusiva durante 12 meses?',
			'openlegal.enter-your-email': 'Introduce tu email',
			'sign-up': 'Regístrate',
			'openlegal.thanks-subscription': '¡Gracias! Te informaremos próximamente.'
		},
		en: {
			'openlegal.promotion-question': 'Do you want us to inform you of the launch and access an exclusive promotion for 12 months?',
			'openlegal.enter-your-email': 'Enter your email',
			'sign-up': 'Sign up',
			'openlegal.thanks-subscription': 'Thank you! We will inform you soon.'
		},
		pt: {
			'openlegal.promotion-question': 'Você quer que informemos você sobre o lançamento e acesse uma promoção exclusiva por 12 meses?',
			'openlegal.enter-your-email': 'Digite seu e-mail',
			'sign-up': 'Inscrever-se',
			'openlegal.thanks-subscription': 'Obrigado! Informaremos você em breve.'
		}
	}
}

export default {
	i18n,
	mixins: [validationsMixin],
	data () {
		return {
			form: {
				email: null,
				hover: false
			},
			subscriptionDone: false
		}
	},
	validations: {
    form: {
			email: {
				email
			}
		}
	},
	methods: {
		signUpButtonClicked () {
			MarketingRepository.subscribePromotionOpenlegal(this.$v.form.email.$model).then((response) => {
				if (response.data) {
					this.subscriptionDone = true
				}
			})
		}
	}
}
</script>

<style lang="scss" scoped>
	.nav {
		
		z-index: 1;
		button {
			top: 1.5rem;
			right: 2.5rem;
			position: absolute;
		}

		@include mobile {
			height: 80px;
		}
	}

	.os-container {
		height: 100vh;
		background-image: url('/static-appopensalud/img/bgs/patterns-bg-2.jpg');
		background-size: cover;
		color: white;
		place-content: center center;
		display: grid;
		text-align: center;
		padding: 0rem 2rem;
		.content {
			z-index: 1;
		}

		.btn-sign-up {
			@include mobile {
				width: 100%;
			}
		}

		.overlay {
			background-color: $blue;
			opacity: .9;
			height: 100vh;
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
		}

		img {
			width: 600px;

			@include mobile {
				width: 280px;
			}

			justify-content: center;
		}
	}

	.ctn-shadow {
			background-color: #ffffff57;
			padding: .25rem;
			border-radius: $border-radius;
			box-shadow: $custom-shadow-bottom;
		}
</style>


// WEBPACK FOOTER //
// src/components/views/openlegal/TemporaryHome.vue